// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LiabilitiesStep_IntegrationLiabilityFragment = { __typename?: 'IntegrationLiability', id: string, integrationID: string, name: string, kind: Types.IntegrationLiabilityKind, externalKind: Types.IntegrationLiabilityExternalKind, value?: CurrencyUSD | null, interestRate?: Percent | null, recurringPaymentAmount?: CurrencyUSD | null, paymentFrequency?: string | null, termStart?: Time | null, termEnd?: Time | null, recipientName?: string | null, integrationClient?: { __typename?: 'IntegrationClient', id: string, kind: Types.IntegrationClientKind } | null };

export type LiabilitiesStepIntegrationLiabilitiesQueryVariables = Types.Exact<{
  householdsLike: Types.HouseholdWhereInput;
  integrationClientKind?: Types.InputMaybe<Types.IntegrationClientKind>;
}>;


export type LiabilitiesStepIntegrationLiabilitiesQuery = { __typename?: 'Query', integrationLiabilities: { __typename?: 'IntegrationLiabilityConnection', edges?: Array<{ __typename?: 'IntegrationLiabilityEdge', node?: (
        { __typename?: 'IntegrationLiability' }
        & LiabilitiesStep_IntegrationLiabilityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    LiabilitiesStepIntegrationLiabilities: 'LiabilitiesStepIntegrationLiabilities' as const
  },
  Fragment: {
    LiabilitiesStep_IntegrationLiability: 'LiabilitiesStep_IntegrationLiability' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const LiabilitiesStep_IntegrationLiabilityFragmentDoc = gql`
    fragment LiabilitiesStep_IntegrationLiability on IntegrationLiability {
  id
  integrationID
  name
  kind
  externalKind
  value
  interestRate
  recurringPaymentAmount
  paymentFrequency
  termStart
  termEnd
  recipientName
  integrationClient {
    id
    kind
  }
}
    `;
export const LiabilitiesStepIntegrationLiabilitiesDocument = gql`
    query LiabilitiesStepIntegrationLiabilities($householdsLike: HouseholdWhereInput!, $integrationClientKind: IntegrationClientKind) {
  integrationLiabilities(
    where: {and: [{hasLiabilities: false}, {hasIntegrationClientWith: [{kind: $integrationClientKind}, {hasClientHouseholdsWith: [$householdsLike]}]}]}
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...LiabilitiesStep_IntegrationLiability
      }
    }
  }
}
    ${LiabilitiesStep_IntegrationLiabilityFragmentDoc}`;

/**
 * __useLiabilitiesStepIntegrationLiabilitiesQuery__
 *
 * To run a query within a React component, call `useLiabilitiesStepIntegrationLiabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiabilitiesStepIntegrationLiabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiabilitiesStepIntegrationLiabilitiesQuery({
 *   variables: {
 *      householdsLike: // value for 'householdsLike'
 *      integrationClientKind: // value for 'integrationClientKind'
 *   },
 * });
 */
export function useLiabilitiesStepIntegrationLiabilitiesQuery(baseOptions: Apollo.QueryHookOptions<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>(LiabilitiesStepIntegrationLiabilitiesDocument, withFetchPolicyContext(options));
      }
export function useLiabilitiesStepIntegrationLiabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>(LiabilitiesStepIntegrationLiabilitiesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLiabilitiesStepIntegrationLiabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>(LiabilitiesStepIntegrationLiabilitiesDocument, withFetchPolicyContext(options));
        }
export type LiabilitiesStepIntegrationLiabilitiesQueryHookResult = ReturnType<typeof useLiabilitiesStepIntegrationLiabilitiesQuery>;
export type LiabilitiesStepIntegrationLiabilitiesLazyQueryHookResult = ReturnType<typeof useLiabilitiesStepIntegrationLiabilitiesLazyQuery>;
export type LiabilitiesStepIntegrationLiabilitiesSuspenseQueryHookResult = ReturnType<typeof useLiabilitiesStepIntegrationLiabilitiesSuspenseQuery>;
export type LiabilitiesStepIntegrationLiabilitiesQueryResult = Apollo.QueryResult<LiabilitiesStepIntegrationLiabilitiesQuery, LiabilitiesStepIntegrationLiabilitiesQueryVariables>;